"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var slider_1 = __importDefault(require("../helpers/slider"));
var utilities_1 = require("../helpers/utilities");
var addToBag_1 = __importDefault(require("./addToBag"));
var PricingOptionsMetred = /** @class */ (function () {
    function PricingOptionsMetred() {
        this.products = [];
    }
    PricingOptionsMetred.prototype.init = function (options) {
        return __awaiter(this, void 0, Promise, function () {
            var form, container;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        form = document.querySelector(options.form);
                        container = document.querySelector(options.container);
                        if (!form || !container)
                            return [2 /*return*/];
                        addToBag_1.default.enabled(false, form);
                        return [4 /*yield*/, this.load(form, container, options)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    PricingOptionsMetred.prototype.load = function (form, container, options) {
        return __awaiter(this, void 0, Promise, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.getProducts(options.handles)];
                    case 1:
                        _a.products = _b.sent();
                        this.addEventListeners(container, form);
                        return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    PricingOptionsMetred.prototype.addEventListeners = function (container, form) {
        var _this = this;
        document.addEventListener('getVariant', this.handleChange.bind(this, form));
        document.querySelectorAll('.product-metred__input').forEach(function (input) { return input.addEventListener('keyup', _this.handleKeyUp); });
    };
    PricingOptionsMetred.prototype.handleKeyUp = function (event) {
        var target = event.currentTarget;
        var split = target.value.split('.');
        var value = target.value;
        var decimalValue;
        if (split.length > 1)
            decimalValue = split[1].substring(0, 1);
        if (decimalValue)
            value = split[0] + '.' + decimalValue;
        target.value = value;
    };
    PricingOptionsMetred.prototype.updateEditValue = function (string, key) {
        var editValues = document.querySelectorAll('[data-product-custom-edit-value]');
        var editValuesArray = Array.from(editValues);
        var editValue = editValuesArray.find(function (editValue) {
            return editValue.dataset.productCustomEditValue === key;
        });
        editValue.textContent = string;
    };
    PricingOptionsMetred.prototype.getProducts = function (handles) {
        return __awaiter(this, void 0, Promise, function () {
            var products;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        products = [];
                        return [4 /*yield*/, Promise.all(handles.map(function (handle) { return __awaiter(_this, void 0, void 0, function () {
                                var _a, _b;
                                return __generator(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            _b = (_a = products).push;
                                            return [4 /*yield*/, (0, axios_1.default)({
                                                    method: 'GET',
                                                    responseType: 'json',
                                                    url: "/products/".concat(handle, ".js")
                                                })];
                                        case 1:
                                            _b.apply(_a, [_c.sent()]);
                                            return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, products];
                }
            });
        });
    };
    PricingOptionsMetred.prototype.handleChange = function (form, event) {
        return __awaiter(this, void 0, void 0, function () {
            var target, isLength, isWidth, length, width, variant, lengths, widths, enabled, _a, btn;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        addToBag_1.default.enableBtnLoading(form);
                        target = (0, utilities_1.isDesktop)() ? document.querySelector('.accordion [data-product-custom-metred-length]') : document.querySelector('.product-custom__panel [data-product-custom-metred-length]');
                        isLength = target.hasAttribute('data-product-custom-metred-length');
                        isWidth = target.hasAttribute('data-product-custom-metred-width');
                        length = document.querySelector('[data-product-custom-metred-length]');
                        width = document.querySelector('[data-product-custom-metred-width]');
                        if (!(isLength || isWidth)) return [3 /*break*/, 5];
                        lengths = document.querySelectorAll('[data-product-custom-metred-length]');
                        widths = document.querySelectorAll('[data-product-custom-metred-width]');
                        length = target.closest('[data-product-custom-metred]').querySelector('[data-product-custom-metred-length]');
                        width = target.closest('[data-product-custom-metred]').querySelector('[data-product-custom-metred-width]');
                        if (!isLength) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getVariant(target.value, width.value)];
                    case 1:
                        variant = _b.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.getVariant(length.value, target.value)];
                    case 3:
                        variant = _b.sent();
                        _b.label = 4;
                    case 4:
                        lengths.forEach(function (l) { return l.value = length.value; });
                        widths.forEach(function (w) { return w.value = width.value; });
                        return [3 /*break*/, 7];
                    case 5: return [4 /*yield*/, this.getVariant(length.value, width.value)];
                    case 6:
                        variant = _b.sent();
                        _b.label = 7;
                    case 7:
                        if (!(variant && !variant.length)) return [3 /*break*/, 9];
                        return [4 /*yield*/, this.checkQuantity(variant.option1)];
                    case 8:
                        _a = _b.sent();
                        return [3 /*break*/, 10];
                    case 9:
                        _a = false;
                        _b.label = 10;
                    case 10:
                        enabled = _a;
                        btn = form.querySelector('[data-add-to-cart-btn]');
                        this.updateEditValue(this.getFormattedValue(length.value, width.value), 'sizing');
                        addToBag_1.default.updateVariant(form, variant);
                        addToBag_1.default.enabled(enabled, form, variant);
                        addToBag_1.default.disableBtnLoading(form);
                        btn.disabled = !enabled;
                        return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    PricingOptionsMetred.prototype.checkQuantity = function (title) {
        return __awaiter(this, void 0, void 0, function () {
            var activePattern, activeBinding, activeOptions, quantities, _a, _b, _i, activeOption, container, isBinding, handle, response, quantity, quantityProperty, area;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        activePattern = document.querySelector('.product-custom__pattern-img--active.pattern');
                        activeBinding = document.querySelector('.product-custom__pattern-img--active.binding');
                        activeOptions = [activePattern, activeBinding];
                        quantities = [];
                        _a = [];
                        for (_b in activeOptions)
                            _a.push(_b);
                        _i = 0;
                        _c.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        activeOption = _a[_i];
                        container = activeOptions[activeOption].parentNode;
                        isBinding = activeOptions[activeOption].classList.contains('binding');
                        handle = isBinding ? container.dataset.productCustomBindingItem : container.dataset.productCustomPatternItem;
                        return [4 /*yield*/, (0, axios_1.default)({
                                method: 'GET',
                                responseType: 'json',
                                url: "/products/".concat(handle, "?view=json")
                            })];
                    case 2:
                        response = _c.sent();
                        quantities.push({
                            value: response.data.quantity,
                            isBinding: isBinding
                        });
                        _c.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4:
                        quantity = quantities[0].value <= quantities[1].value ? quantities[0] : quantities[1];
                        quantityProperty = document.querySelector('[data-product-quantity-handle]');
                        area = quantities.reduce(function (acc, quantity) {
                            var calc = (0, utilities_1.calcQuantityByArea)(title, quantity.isBinding);
                            if (calc > acc)
                                acc = calc;
                            return acc;
                        }, 0);
                        quantityProperty.value = quantity.value.toString();
                        return [2 /*return*/, area <= quantity.value ? true : false];
                }
            });
        });
    };
    PricingOptionsMetred.prototype.getFormattedValue = function (length, width) {
        var formattedLengthValue = length.includes('.') ? length : length + '.0';
        var formattedWidthValue = width.includes('.') ? width : width + '.0';
        var formattedValue = formattedWidthValue ? formattedLengthValue + 'm x ' + formattedWidthValue + 'm' : formattedLengthValue + 'm';
        if (parseFloat(length) > parseFloat(width) && width) {
            formattedValue = formattedWidthValue + 'm x ' + formattedLengthValue + 'm';
        }
        return formattedValue;
    };
    PricingOptionsMetred.prototype.getVariant = function (length, width) {
        return __awaiter(this, void 0, Promise, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, Promise.resolve(this.products.reduce(function (acc, product) {
                        var variant = product.data.variants.find(function (variant) {
                            return variant.title === _this.getFormattedValue(length, width);
                        });
                        if (variant)
                            acc = variant;
                        return acc;
                    }, []))];
            });
        });
    };
    return PricingOptionsMetred;
}());
var CustomRug = /** @class */ (function () {
    function CustomRug() {
        this.pricingOptions = new PricingOptionsMetred();
        this.config = {
            panels: {
                index: 0,
                keys: ['pattern', 'binding', 'sizing', 'purchase']
            },
            responses: {
                settings: null,
                sizings: {},
                bindings: {},
                patterns: {}
            },
            selector: {
                main: '[data-product-custom]',
                patterns: '[data-product-custom-patterns]',
                bindings: '[data-product-custom-bindings]',
                actions: '[data-product-custom-actions]',
                accordion: '[data-product-custom-accordion]',
                edit: '[data-product-custom-edit]',
                sizings: '[data-product-custom-metred]',
                editBtn: '[data-product-custom-edit-btn]',
                panel: '[data-product-custom-panel]',
                patternItem: '[data-product-custom-pattern-item]',
                bindingItem: '[data-product-custom-binding-item]',
                next: '[data-product-custom-next]',
                back: '[data-product-custom-back]'
            },
            loaded: {
                pattern: false,
                binding: false,
                sizing: false,
            },
            className: {
                loading: 'product-custom--loading',
                hide: 'hide'
            },
            nodeList: {
                patternItems: null,
                bindingItems: null,
                accordions: null,
                patterns: null,
                bindings: null,
                sizings: null,
                editBtns: null,
                panels: null
            },
            selected: {
                pattern: null
            },
            htmlElement: {
                main: null,
                actions: null,
                edit: null,
                next: null,
                back: null
            }
        };
    }
    CustomRug.prototype.init = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.config.htmlElement.main = document.querySelector(this.config.selector.main);
                        if (!this.config.htmlElement.main)
                            return [2 /*return*/];
                        this.setElements();
                        this.loading(true);
                        return [4 /*yield*/, this.loadSettings()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.loadPatterns()];
                    case 2:
                        _a.sent();
                        this.update(this.config.panels.keys[0]);
                        this.addEventListeners();
                        this.loading(false);
                        return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    CustomRug.prototype.loading = function (loading) {
        if (loading)
            return this.config.htmlElement.main.classList.add(this.config.className.loading);
        return this.config.htmlElement.main.classList.remove(this.config.className.loading);
    };
    CustomRug.prototype.setElements = function () {
        this.config.nodeList.patternItems = document.querySelectorAll(this.config.selector.patternItem);
        this.config.nodeList.bindingItems = document.querySelectorAll(this.config.selector.bindingItem);
        this.config.nodeList.panels = document.querySelectorAll(this.config.selector.panel);
        this.config.nodeList.editBtns = document.querySelectorAll(this.config.selector.editBtn);
        this.config.nodeList.patterns = document.querySelectorAll(this.config.selector.patterns);
        this.config.nodeList.bindings = document.querySelectorAll(this.config.selector.bindings);
        this.config.nodeList.accordions = document.querySelectorAll(this.config.selector.accordion);
        this.config.nodeList.sizings = document.querySelectorAll(this.config.selector.sizings);
        this.config.htmlElement.next = document.querySelector(this.config.selector.next);
        this.config.htmlElement.back = document.querySelector(this.config.selector.back);
        this.config.htmlElement.actions = document.querySelector(this.config.selector.actions);
        this.config.htmlElement.edit = document.querySelector(this.config.selector.edit);
    };
    CustomRug.prototype.addEventListeners = function () {
        var _this = this;
        this.setElements();
        this.config.htmlElement.next.addEventListener('click', this.handleNextClick.bind(this));
        this.config.htmlElement.back.addEventListener('click', this.handleBackClick.bind(this));
        this.config.nodeList.editBtns.forEach(function (htmlElement) { return htmlElement.addEventListener('click', _this.handleEditBtnClick.bind(_this)); });
        var popularSizesBtns = document.querySelectorAll('[data-product-custom-popular-sizes-btn]');
        popularSizesBtns.forEach(function (popularSizesBtn) { return popularSizesBtn.addEventListener('click', _this.handlePopularSizesBtnClick.bind(_this)); });
        var popularSizesItems = document.querySelectorAll('[data-product-custom-popular-sizes-item]');
        popularSizesItems.forEach(function (popularSizesItem) { return popularSizesItem.addEventListener('click', _this.handlePopularSizesItemClick.bind(_this)); });
        document.querySelectorAll('.product-custom__progress-items').forEach(function (progressItemContainer) {
            var progressItems = progressItemContainer.querySelectorAll('[data-product-custom-progress-item]');
            progressItems.forEach(function (progressItem, index) {
                progressItem.addEventListener('click', _this.handleProgressItemClick.bind(_this, progressItem, index), false);
            });
        });
    };
    CustomRug.prototype.handleEditBtnClick = function (event) {
        var target = event.currentTarget;
        this.config.panels.index = this.config.panels.keys.reduce(function (acc, key, index) {
            if (key === target.dataset.productCustomEditBtn)
                acc = index;
            return acc;
        }, 0);
        this.hidePanelsAndAccordions(false);
        this.hideActions(false);
        this.update(target.dataset.productCustomEditBtn);
    };
    CustomRug.prototype.update = function (key) {
        this.updateActionBtns(key);
        this.updateActivePanels(key);
        this.updateActiveAccordion(key);
        this.updateActiveProgressBar(key);
        this.updateActiveInfo(key);
    };
    CustomRug.prototype.updateActiveInfo = function (key) {
        var _this = this;
        var infos = document.querySelector('.product-custom__infos');
        var keys = infos.querySelectorAll('[data-key]');
        var active = infos.querySelector("[data-key=\"".concat(key, "\"]"));
        keys.forEach(function (key) { return key.classList.add(_this.config.className.hide); });
        if (active)
            active.classList.remove(this.config.className.hide);
    };
    CustomRug.prototype.updateActionBtns = function (key) {
        switch (key) {
            case 'pattern':
                var isPatternSelected = document.querySelector('.product-custom__pattern-img--active.pattern') ? true : false;
                this.config.htmlElement.next.disabled = !isPatternSelected;
                this.config.htmlElement.back.disabled = true;
                break;
            case 'binding':
                var isBindingSelected = document.querySelector('.product-custom__pattern-img--active.binding') ? true : false;
                this.config.htmlElement.next.disabled = !isBindingSelected;
                this.config.htmlElement.back.disabled = false;
                break;
            case 'sizing':
                this.config.htmlElement.next.disabled = false;
                this.config.htmlElement.back.disabled = false;
                break;
        }
    };
    CustomRug.prototype.handleNextClick = function () {
        return __awaiter(this, void 0, void 0, function () {
            var evt;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.config.panels.index += 1;
                        if (this.config.panels.index === (this.config.panels.keys.length - 1)) {
                            evt = document.createEvent("HTMLEvents");
                            this.hideActions(true);
                            this.hidePanelsAndAccordions(true);
                            this.update(null);
                            evt.initEvent('getVariant', false, true);
                            document.dispatchEvent(evt);
                        }
                        return [4 /*yield*/, this.loadPanel(this.config.panels.keys[this.config.panels.index])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    CustomRug.prototype.updateActiveProgressBar = function (key) {
        var progressItemContainers = document.querySelectorAll('.product-custom__progress-items');
        progressItemContainers.forEach(function (progressItemContainer) {
            var progressItems = progressItemContainer.querySelectorAll('[data-product-custom-progress-item]');
            var foundActive = false;
            progressItems.forEach(function (progressItem) {
                progressItem.classList.remove('product-custom__progress-item--active');
                if (!foundActive) {
                    progressItem.classList.add('product-custom__progress-item--active');
                }
                if (progressItem.dataset.productCustomProgressItem === key) {
                    foundActive = true;
                }
            });
        });
    };
    CustomRug.prototype.handleProgressItemClick = function (progressItem, index) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!progressItem.classList.contains('product-custom__progress-item--active')) return [3 /*break*/, 2];
                        this.hidePanelsAndAccordions(false);
                        this.hideActions(false);
                        this.config.panels.index = index;
                        return [4 /*yield*/, this.loadPanel(this.config.panels.keys[this.config.panels.index])];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    CustomRug.prototype.handleBackClick = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.config.panels.index -= 1;
                        return [4 /*yield*/, this.loadPanel(this.config.panels.keys[this.config.panels.index])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    CustomRug.prototype.handlePatternClick = function (event) {
        var target = event.currentTarget;
        var patterns = this.config.responses.patterns.data;
        var key = target.dataset.productCustomPatternItem;
        var pattern = patterns[key];
        var previewPattern = document.querySelector('[data-preview-pattern]');
        this.config.nodeList.patternItems.forEach(function (patternItem) {
            patternItem.children[0].classList.remove('product-custom__pattern-img--active');
            patternItem.children[0].classList.remove('pattern');
        });
        target.children[0].classList.add('product-custom__pattern-img--active');
        target.children[0].classList.add('pattern');
        if (pattern.images.length)
            previewPattern.style.backgroundImage = "url( ".concat(pattern.images[0], ")");
        this.updateEditValue(pattern, 'pattern');
        var patternProperty = document.querySelector('[data-product-custom-pattern-property]');
        var patternID = document.querySelector('[data-product-custom-pattern-id-property]');
        patternID.value = pattern.id;
        patternProperty.value = pattern.title;
        this.config.selected.pattern = target.dataset.productCustomPatternItem;
        this.update('pattern');
    };
    CustomRug.prototype.updateEditValue = function (response, key) {
        var editValues = document.querySelectorAll('[data-product-custom-edit-value]');
        var editValuesArray = Array.from(editValues);
        var editValue = editValuesArray.find(function (editValue) {
            return editValue.dataset.productCustomEditValue === key;
        });
        editValue.textContent = response.title;
    };
    CustomRug.prototype.handleBindingClick = function (event) {
        var target = event.currentTarget;
        var key = target.dataset.productCustomBindingItem;
        var bindings = this.config.responses.bindings.data;
        var binding = bindings[key];
        var previewBinding = document.querySelector('[data-preview-binding]');
        this.config.nodeList.bindingItems.forEach(function (bindingItem) {
            bindingItem.children[0].classList.remove('product-custom__pattern-img--active');
            bindingItem.children[0].classList.remove('binding');
        });
        target.children[0].classList.add('product-custom__pattern-img--active');
        target.children[0].classList.add('binding');
        if (binding.images.length)
            previewBinding.style.backgroundImage = "url( ".concat(binding.images[0], ")");
        this.updateEditValue(binding, 'binding');
        var bindingProperty = document.querySelector('[data-product-custom-binding-property]');
        var bindingID = document.querySelector('[data-product-custom-binding-id-property]');
        bindingProperty.value = binding.title;
        bindingID.value = binding.id;
        this.update('binding');
    };
    CustomRug.prototype.updateActiveAccordion = function (key) {
        var lastPanel = this.config.panels.index === this.config.panels.keys.length - 1;
        var active = Array.from(this.config.nodeList.accordions).find(function (accordion) { return accordion.dataset.productCustomAccordion === key; });
        var accordions = document.querySelector('.product-custom__accordions');
        this.config.htmlElement.edit.classList.add(this.config.className.hide);
        if (active) {
            var activePanel = active.querySelector('[data-accordion-panel]');
            accordions.classList.remove('hide--md-up');
            this.config.nodeList.accordions.forEach(function (accordion) {
                var panel = accordion.querySelector('[data-accordion-panel]');
                (0, utilities_1.openPanel)(panel, false);
            });
            return (0, utilities_1.openPanel)(activePanel, true);
        }
        if (lastPanel) {
            accordions.classList.add('hide--md-up');
            this.config.htmlElement.edit.classList.remove(this.config.className.hide);
        }
    };
    CustomRug.prototype.updateActivePanels = function (key) {
        var _this = this;
        var lastPanel = this.config.panels.index === this.config.panels.keys.length - 1;
        var activePanel = Array.from(this.config.nodeList.panels).find(function (panel) { return panel.dataset.key === key; });
        var panels = document.querySelector('.product-custom__panels');
        if (activePanel) {
            panels.classList.remove('hide--sm');
            this.config.htmlElement.edit.classList.add(this.config.className.hide);
            this.config.nodeList.panels.forEach(function (panel) { return panel.classList.add(_this.config.className.hide); });
            return activePanel.classList.remove(this.config.className.hide);
        }
        if (lastPanel) {
            panels.classList.add('hide--sm');
            this.config.htmlElement.edit.classList.remove(this.config.className.hide);
        }
    };
    CustomRug.prototype.loadPanel = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loading(true);
                        _a = key;
                        switch (_a) {
                            case 'pattern': return [3 /*break*/, 1];
                            case 'binding': return [3 /*break*/, 4];
                            case 'sizing': return [3 /*break*/, 7];
                        }
                        return [3 /*break*/, 10];
                    case 1:
                        if (!!this.config.loaded.pattern) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.loadPatterns()];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3: return [3 /*break*/, 10];
                    case 4:
                        if (!!this.config.loaded.binding) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.loadBindings()];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6: return [3 /*break*/, 10];
                    case 7:
                        if (!!this.config.loaded.sizing) return [3 /*break*/, 9];
                        return [4 /*yield*/, this.loadSizings()];
                    case 8:
                        _b.sent();
                        _b.label = 9;
                    case 9: return [3 /*break*/, 10];
                    case 10:
                        this.update(key);
                        this.loading(false);
                        return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    CustomRug.prototype.loadSettings = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.config.responses;
                        return [4 /*yield*/, (0, axios_1.default)({ method: 'GET', responseType: 'json', url: '/pages/settings' })];
                    case 1:
                        _a.settings = _b.sent();
                        return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    CustomRug.prototype.loadPatterns = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.config.responses;
                        return [4 /*yield*/, this.getCollection('custom-rug-carpets')];
                    case 1:
                        _a.patterns = _b.sent();
                        this.config.nodeList.patterns.forEach(function (pattern) { return pattern.insertAdjacentHTML('afterbegin', _this.getPatternImgsHTML()); });
                        slider_1.default.init(this.config.nodeList.patterns[0], {
                            items: 6.5,
                            // @ts-ignore
                            preventScrollOnTouch: 'auto'
                        });
                        this.setElements();
                        this.config.nodeList.patternItems.forEach(function (htmlElement) { return htmlElement.addEventListener('click', _this.handlePatternClick.bind(_this)); });
                        this.config.loaded.pattern = true;
                        return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    CustomRug.prototype.loadBindings = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.config.responses;
                        return [4 /*yield*/, this.getCollection('custom-rug-bindings')];
                    case 1:
                        _a.bindings = _b.sent();
                        this.config.nodeList.bindings.forEach(function (binding) { return binding.insertAdjacentHTML('afterbegin', _this.getBindingImgsHTML()); });
                        slider_1.default.init(this.config.nodeList.bindings[0], {
                            items: 6.5,
                            // @ts-ignore
                            preventScrollOnTouch: 'auto'
                        });
                        this.setElements();
                        this.config.nodeList.bindingItems.forEach(function (htmlElement) { return htmlElement.addEventListener('click', _this.handleBindingClick.bind(_this)); });
                        this.config.loaded.binding = true;
                        return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    CustomRug.prototype.loadSizings = function () {
        return __awaiter(this, void 0, void 0, function () {
            var product;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        product = document.querySelector('[data-product-custom]');
                        this.config.nodeList.sizings.forEach(function (sizing) {
                            sizing.innerHTML = '';
                            sizing.insertAdjacentHTML('afterbegin', _this.getSizingImgsHTML());
                        });
                        return [4 /*yield*/, this.pricingOptions.init({
                                form: '[data-add-to-cart]',
                                container: this.config.selector.sizings,
                                pattern: this.config.selected.pattern,
                                handles: this.config.responses.settings.data.pricing.custom[product.dataset.productCustom],
                                width: {
                                    min: this.config.responses.settings.data.settings.customWidthMin,
                                    max: this.config.responses.settings.data.settings.customWidthMax
                                },
                                length: {
                                    min: this.config.responses.settings.data.settings.customLengthMin,
                                    max: this.config.responses.settings.data.settings.customLengthMax
                                }
                            })];
                    case 1:
                        _a.sent();
                        this.config.loaded.sizing = true;
                        return [2 /*return*/, Promise.resolve(true)];
                }
            });
        });
    };
    CustomRug.prototype.handlePopularSizesBtnClick = function () {
        var popularSizesBtns = document.querySelectorAll('[data-product-custom-popular-sizes-btn]');
        popularSizesBtns.forEach(function (popularSizesBtn) {
            var accordionPanel = popularSizesBtn.closest('[data-accordion-panel]');
            var container = popularSizesBtn.closest('.product-custom__popular-sizes');
            container.classList.toggle('product-custom__popular-sizes--active');
            (0, utilities_1.openPanel)(accordionPanel, true);
        });
    };
    CustomRug.prototype.handlePopularSizesItemClick = function (event) {
        var target = event.currentTarget;
        var popularSizesItems = document.querySelectorAll('[data-product-custom-popular-sizes-item]');
        popularSizesItems.forEach(function (popularSizesItem) {
            popularSizesItem.classList.remove('product-custom__popular-sizes-item--active');
        });
        var text = target.querySelector('.product-custom__popular-sizes-length');
        var lengths = document.querySelectorAll('[data-product-custom-metred-width]');
        var widths = document.querySelectorAll('[data-product-custom-metred-length]');
        var dimensions = text.textContent.split('x').reverse();
        dimensions = dimensions.map(function (dimension) { return dimension.replace('m', '').trim(); });
        lengths.forEach(function (length) { return length.value = dimensions[0]; });
        widths.forEach(function (width) { return width.value = dimensions[1]; });
        this.handlePopularSizesBtnClick();
        target.classList.add('product-custom__popular-sizes-item--active');
    };
    CustomRug.prototype.hideActions = function (hide) {
        if (hide)
            return this.config.htmlElement.actions.classList.add(this.config.className.hide);
        return this.config.htmlElement.actions.classList.remove(this.config.className.hide);
    };
    CustomRug.prototype.hidePanelsAndAccordions = function (hide) {
        var _this = this;
        if (hide) {
            this.config.nodeList.accordions.forEach(function (accordion) { return accordion.classList.add(_this.config.className.hide); });
            this.config.nodeList.panels.forEach(function (accordion) { return accordion.classList.add(_this.config.className.hide); });
            return;
        }
        this.config.nodeList.accordions.forEach(function (accordion) { return accordion.classList.remove(_this.config.className.hide); });
        this.config.nodeList.panels.forEach(function (accordion) { return accordion.classList.remove(_this.config.className.hide); });
        return;
    };
    CustomRug.prototype.getCollection = function (collectionHandle) {
        return __awaiter(this, void 0, Promise, function () {
            var collection, product;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, axios_1.default)({
                            method: 'GET',
                            responseType: 'json',
                            url: "/collections/".concat(collectionHandle, "?view=json")
                        })];
                    case 1:
                        collection = _a.sent();
                        for (product in collection.data) {
                            if (!collection.data[product].available)
                                delete collection.data[product];
                        }
                        return [2 /*return*/, Promise.resolve(collection)];
                }
            });
        });
    };
    CustomRug.prototype.getSizingImgsHTML = function () {
        var html = "\n      <div class=\"product-metred\">\n        <div class=\"product-metred__group\">\n          <label class=\"product-metred__label\">Length (Min ".concat(this.config.responses.settings.data.settings.customLengthMin, "m, Max ").concat(this.config.responses.settings.data.settings.customLengthMax, "m)</label>\n          <div class=\"product-metred__input-wrapper\">\n            <input\n              class=\"product-metred__input\"\n              type=\"number\"\n              data-product-custom-metred-length\n              step=\"").concat(this.config.responses.settings.data.settings.customInterval, "\"\n              min=\"").concat(this.config.responses.settings.data.settings.customLengthMin, "\"\n              max=\"").concat(this.config.responses.settings.data.settings.customLengthMax, "\"\n              value=\"").concat(this.config.responses.settings.data.settings.customLengthMin, "\"\n            />\n            <span class=\"product-metred__icon\">m</span>\n          </div>\n        </div>\n        <div class=\"product-metred__group\">\n          <label class=\"product-metred__label\">Width (Min ").concat(this.config.responses.settings.data.settings.customWidthMin, "m, Max ").concat(this.config.responses.settings.data.settings.customWidthMax, "m)</label>\n          <div class=\"product-metred__input-wrapper\">\n            <input\n              class=\"product-metred__input\"\n              type=\"number\"\n              data-product-custom-metred-width\n              step=\"").concat(this.config.responses.settings.data.settings.customInterval, "\"\n              min=\"").concat(this.config.responses.settings.data.settings.customWidthMin, "\"\n              max=\"").concat(this.config.responses.settings.data.settings.customWidthMax, "\"\n              value=\"").concat(this.config.responses.settings.data.settings.customWidthMin, "\"\n            />\n            <span class=\"product-metred__icon\">m</span>\n          </div>\n        </div>\n      </div>\n    ");
        return html;
    };
    CustomRug.prototype.getPatternImgsHTML = function () {
        var html = '';
        var patterns = this.config.responses.patterns.data;
        for (var _i = 0, _a = Object.keys(patterns); _i < _a.length; _i++) {
            var pattern = _a[_i];
            var _b = patterns[pattern], images = _b.images, title = _b.title;
            var image = images.length ? images[0] : null;
            var style = image ? "style=\"background-image: url(".concat(image, ");\"") : '';
            html += "\n        <div class=\"product-custom__pattern-img-slide\" data-product-custom-pattern-item=\"".concat(pattern, "\">\n          <div class=\"product-custom__pattern-img\" ").concat(style, ">\n            <div class=\"product-custom__pattern-text\">\n              ").concat(title, "\n            </div>\n          </div>\n        </div>\n      ");
        }
        return html;
    };
    CustomRug.prototype.getBindingImgsHTML = function () {
        var html = '';
        var bindings = this.config.responses.bindings.data;
        console.log(bindings);
        for (var _i = 0, _a = Object.keys(bindings); _i < _a.length; _i++) {
            var binding = _a[_i];
            var _b = bindings[binding], images = _b.images, title = _b.title;
            var image = images.length ? images[0] : null;
            var style = image ? "style=\"background-image: url(".concat(image, ");\"") : '';
            html += "\n        <div class=\"product-custom__pattern-img-slide\" data-product-custom-binding-item=\"".concat(binding, "\">\n          <div class=\"product-custom__pattern-img\" ").concat(style, ">\n            <div class=\"product-custom__pattern-text\">\n              ").concat(title, "\n            </div>\n          </div>\n        </div>\n      ");
        }
        return html;
    };
    return CustomRug;
}());
exports.default = new CustomRug();
